<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Hotel Service Add
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <ValidationProvider 
                            name="Title" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Title
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : Room Service"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.title"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <ValidationProvider 
                            name="Type" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Type
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : ROOM SERVICE"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="type"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.type = ''"
                              
                              v-model="form.type"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <div
                        class="mb-6">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Description
                        </div>

                        <quill-editor 
                          ref="myTextEditor"
                          :options="{
                            placeholder: 'Ex : Write description in here . . .'
                          }"
                          v-model="form.description">
                        </quill-editor>
                      </div>

                      <div
                        class="mb-6">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Image Thumbnail
                        </div>

                        <folder v-if="form.thumbnail_image === ''"
                          v-model="upload.folder">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 10px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.file"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </folder>

                        <v-card v-if="form.thumbnail_image !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 10px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar v-if="!process.file"
                            v-ripple
                            tile 
                            width="200"
                            height="200">
                            <v-img 
                              width="100%"
                              height="100%"
                              alt="tvandroid" 
                              :src="form.thumbnail_image"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.thumbnail_image = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div>

                      <div
                        class="mb-2">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Items
                        </div>

                        <v-btn
                          @click="add_item()"
                          color="#0786BE"
                          elevation="0"
                          class="body-2 white--text text-capitalize d-flex align-center mb-4"
                          style="font-weight: 600; border-radius: 8px;">
                          <v-icon>mdi-plus-circle-outline</v-icon>
                          
                          <span
                            class="ml-1">
                            Add Item
                          </span>
                        </v-btn>

                        <v-row
                          v-for="(item, index) in form.items_json_array"
                          :key="index">
                          <v-col
                            cols="12"
                            md="1">
                            <div>
                              <folder v-if="item.image === ''"
                                v-model="upload.item">
                                <div 
                                  slot="activator">
                                  <v-card 
                                    @click="item_index = index"
                                    flat
                                    width="100%"
                                    height="90"
                                    class="d-flex align-center justify-center cursor-pointer"
                                    style="border-radius: 10px;
                                          border: 2px solid #EBEBEB; 
                                          border-style: dashed;">
                                    <v-avatar v-if="!item.process"
                                      v-ripple
                                      tile 
                                      width="100%"
                                      height="90">
                                      <v-icon
                                        size="30"
                                        color="#B9B9B9">
                                        mdi-cloud-upload-outline
                                      </v-icon>
                                    </v-avatar>

                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-card>
                                </div>
                              </folder>

                              <v-card v-if="item.image !== ''"
                                flat
                                width="100%"
                                height="90"
                                class="d-flex align-center justify-center"
                                style="border-radius: 10px;
                                      border: 2px solid #EBEBEB; 
                                      border-style: dashed;">
                                <v-avatar
                                  v-ripple
                                  tile 
                                  width="100%"
                                  height="90">
                                  <v-img 
                                    contain
                                    width="100%"
                                    height="100%"
                                    alt="tvandroid" 
                                    :src="item.image"
                                    class="ma-auto">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-avatar>

                                <v-icon 
                                  @click="item.image = ''"
                                  color="red"
                                  class="cursor-pointer"
                                  style="position: absolute; top: -10px; right: -10px;">
                                  mdi-close-circle
                                </v-icon>
                              </v-card>
                            </div>
                          </v-col>

                          <v-col
                            cols="12"
                            md="6">
                            <ValidationProvider 
                              name="Label" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense

                                :color="set_color"
                                :placeholder="`Ex : Item ${index + 1}`"
                                :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                v-model="item.label"
                                :success="valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          
                          <v-col
                            cols="12"
                            md="4">
                            <v-btn
                              @click="form.items_json_array.splice(index, 1)"
                              min-width="36"
                              color="red"
                              elevation="0"
                              class="white--text px-2"
                              style="border-radius: 8px;">
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        type: [
          {
            text: 'ROOM SERVICE',
            value: 'ROOM_SERVICE'
          },
          {
            text: 'BELL BOY',
            value: 'BELL_BOY'
          },
          {
            text: 'ENGINEERING',
            value: 'ENGINEERING'
          },
          {
            text: 'WAKE UP CALL',
            value: 'WAKE_UP_CALL'
          }
        ],

        form: {
          title: '',
          type: '',
          description: '',
          thumbnail_image: '',
          items_json_array: []
        },

        upload: {
          folder: null,
          item: null
        },

        item_index: '',

        process: {
          form: false,

          file: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      folder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.thumbnail_image = this.upload.folder.file_url
            }
          }
        },
        deep: true
      },

      'upload.item': {
        handler: function () {
          if (this.upload.item) {
            this.form.items_json_array[this.item_index].process = this.upload.item.process

            if (!this.form.items_json_array[this.item_index].process) {
              this.form.items_json_array[this.item_index].image = this.upload.item.file_url
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      add_item () {
        this.form.items_json_array.push({
          label: '',
          image: '',
          process: false
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/service/add`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.$router.push('/room')
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>